__turbopack_context__.v({
  "heroContainer": "Hero-module-scss-module___Otqra__heroContainer",
  "heroContent": "Hero-module-scss-module___Otqra__heroContent",
  "infoContainer": "Hero-module-scss-module___Otqra__infoContainer",
  "templateHeading": "Hero-module-scss-module___Otqra__templateHeading",
  "verticalDivider": "Hero-module-scss-module___Otqra__verticalDivider",
});
